<template>
    <Doughnut
        :id="id"
        :options="options"
        :data="data"
        :style="style"
        :plugins="[ChartDataLabels]"
    />
</template>

<script setup>
import { ref, defineProps, onMounted, watch } from 'vue';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';

const props = defineProps([
    'id',
    'options',
    'data',
    'style'
])

const centerTextPlugin = {
  id: 'centerText',
  afterDraw: function(chart) {
    const ctx = chart.ctx;
    const centerX = chart.canvas.width / 2;
    const centerY = chart.canvas.height / 2 + 20;
    console.log(centerX, centerY)
    const options = chart.config.options.plugins.centerText;
    if (options.display) {
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = options.fontSize + 'px ' + options.fontFamily;
      ctx.fillStyle = options.color;
      ctx.fillText(options.text, centerX, centerY);
      ctx.restore();
    }
  }
};

ChartJS.register(ArcElement, Tooltip, Legend, centerTextPlugin, ChartDataLabels)


</script>